// utils/waitForFonts.js

export function waitForFonts(fontFamilies, timeout = 10000) {
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => reject(new Error(`Fonts not loaded within ${timeout}ms`)), timeout)
  })

  const loadPromise = (async () => {
    const found = new Map()

    for (const family of fontFamilies) {
      const matches = [...document.fonts].filter((f) =>
        f.family.replace(/['"]/g, '').toLowerCase().includes(family.toLowerCase())
      )

      if (!matches.length) {
        console.warn(`[waitForFonts] Δεν βρέθηκε FontFace για "${family}"`)
        continue
      }

      // Φορτώνει ρητά ΟΛΑ τα matching faces (π.χ. διαφορετικά weights/styles)
      const loaded = await Promise.all(
        matches.map((f) => f.load().catch((err) => {
          console.warn(`[waitForFonts] Απέτυχε load για "${f.family}":`, err)
          return null
        }))
      )

      const ok = loaded.find(Boolean)
      if (ok) found.set(family, ok.family)
    }

    if (found.size !== fontFamilies.length) {
      const missing = fontFamilies.filter((f) => !found.has(f))
      throw new Error(`Fonts not loaded: ${missing.join(', ')}`)
    }

    return [...found.values()]
  })()

  return Promise.race([loadPromise, timeoutPromise])
}